import styled from 'styled-components';

const SearchStyle = styled.section`
	--rowGap: var(--sp8x);
	--btnPad: var(--sp2x);
	--btnBorderRadius: var(--sp1-5x);
	--fieldWrapperPad: var(--sp1x) var(--sp1x) var(--sp1x) var(--sp3x);
	--fieldWrapperRadiusSize: var(--sp1-5x);

	margin-top: var(--pageDistance);
	margin-bottom: var(--core_sectionDistance);

	.bottom-container {
		margin-top: var(--titleContentDistance);

		.row {
			row-gap: var(--rowGap);
		}
	}
	.pagination-wrapper {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.right-arrow {
		transform: rotate(268deg);
	}
	.left-arrow {
		transform: rotate(90deg);
	}
	.search-field-container {
		margin-top: var(--titleContentDistance);
		display: flex;
		align-items: center;
		position: relative;
	}

	.search-input-wrapper {
		display: flex;
		align-items: center;
		flex: 1;
		border: 1px solid #ddd;
		border-radius: 8px;
		overflow: hidden;
		display: flex;
		justify-content: space-between;
		gap: var(--gutter);
		padding: var(--fieldWrapperPad);
		border-radius: 1px solid var(--gray400);
		border-radius: var(--fieldWrapperRadiusSize);
		background-color: var(--white1000);
	}

	.search-field,
	.search-field::placeholder {
		flex: 1;
		padding: unset !important;
		border: none;
		outline: none;
		font-size: var(--input) !important;
		line-height: var(--form_lineHeight);
		font-family: var(--montserrat_arm);
		font-weight: 400;
	}

	.search-button {
		display: flex;
		align-items: center;
		justify-content: center;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		padding: var(--btnPad);
		color: var(--white1000);
		background-color: var(--red1000);
		border-radius: var(--btnBorderRadius);
		border: 1px solid var(--red1000);
		transition: all var(--trTime) ease-out;
		cursor: pointer;
	}

	.search-button:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}

	.no-results {
		margin-top: var(--titleContentDistance);
		display: flex;
		flex-direction: column;
		gap: var(--sp2x);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--rowGap: var(--sp6x);
		--btnPad: var(--sp2x);
		--fieldWrapperPad: var(--sp1x) var(--sp1x) var(--sp1x) var(--sp3x);
		--fieldWrapperRadiusSize: var(--sp1-5x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--rowGap: var(--sp5x);
		--btnPad: var(--sp2x);
		--fieldWrapperPad: var(--sp1x) var(--sp1x) var(--sp1x) var(--sp2x);
		--fieldWrapperRadiusSize: var(--sp1-5x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--rowGap: var(--sp4x);
		--btnPad: var(--sp2x);
		--fieldWrapperPad: var(--sp1x) var(--sp1x) var(--sp1x) var(--sp2x);
		--fieldWrapperRadiusSize: var(--sp1-5x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--rowGap: var(--sp4x);
		--btnPad: var(--sp2x);
		--fieldWrapperPad: var(--sp1x) var(--sp1x) var(--sp1x) var(--sp2x);
		--fieldWrapperRadiusSize: var(--sp1-5x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--rowGap: var(--sp3x);
		--btnPad: var(--sp1-5x);
		--fieldWrapperPad: var(--sp0-5x) var(--sp0-5x) var(--sp0-5x) var(--sp2x);
		--fieldWrapperRadiusSize: var(--sp1-5x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--rowGap: var(--sp3x);
		--btnPad: var(--sp1-5x);
		--fieldWrapperPad: var(--sp0-5x) var(--sp0-5x) var(--sp0-5x) var(--sp1-5x);
		--fieldWrapperRadiusSize: var(--sp1x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--rowGap: var(--sp3x);
		--btnPad: var(--sp1-5x);
		--fieldWrapperPad: var(--sp0-5x) var(--sp0-5x) var(--sp0-5x) var(--sp1-5x);
		--fieldWrapperRadiusSize: var(--sp1x);
	}
`;

export default SearchStyle;
